import api from '@/api/auditlog'

const state = {
    items: [],
    pagination: null,
}

const mutations = {
    set(state, payload) {
        state.items = payload
    },
    delete(state, id) {
        let index = state.items.findIndex(x => x.id == id)
        state.items.splice(index, 1)
    },
    set_pagination(state, pag) {
        state.pagination = pag
    },
}

const actions = {
    fetch(context, payload) {
        return api
            .fetch(payload)
            .then(
                ({
                    data: {
                        success: { data: pag },
                    },
                }) => {
                    //result.data.success.data.data
                    let users = pag.data
                    context.commit('set', users)
                    //let pag = result.data.success.data
                    context.commit('set_pagination', {
                        page: pag.current_page,
                        pageSize: pag.per_page,
                        total: pag.total,
                    })
                }
            )
            .catch(err => {
                throw err
            })
    },
    delete(context, id) {
        return api
            .delete(id)
            .then(() => context.commit('delete', id))
            .catch(err => {
                throw err
            })
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
